import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import { initCarousels } from "../modules/product-collection";
import "../../scss/brand.scss";

async function initCategoryPage() {
  await initTranslation();
  initPage();
  initCarousels();
}

initCategoryPage();
